import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../priceFormatting';
import { seriesPassProductShape } from '../productShape';
import { formatVenueDateTime } from '../../../shared/venueZoneFormatting';

const formatIncreaseDate = (iso) => formatVenueDateTime(iso, { month: 'long' });

export default function ProductPrice({ product, currency, enableAllInPricing, showFeeBreakdown }) {
  const headline = product.calculatedPrice != null ? product.calculatedPrice : product.price;
  const showDescription = enableAllInPricing && showFeeBreakdown && product.allInPriceDescription;
  const { upcomingPrice } = product;
  const upcomingHeadline =
    upcomingPrice && (upcomingPrice.calculatedPrice != null ? upcomingPrice.calculatedPrice : upcomingPrice.price);

  return (
    <span className="series-pass-product-price">
      <span data-testid={`series-pass-product-price-${product.id}`}>
        {formatPrice(headline, currency)}
      </span>
      {showDescription && (
        <span
          className="series-pass-product-price-description text-muted"
          data-testid={`series-pass-product-price-description-${product.id}`}
        >
          {product.allInPriceDescription}
        </span>
      )}
      {upcomingPrice && Number(upcomingHeadline) !== Number(headline) && (
        <span
          className="series-pass-product-price-upcoming text-muted"
          data-testid={`series-pass-product-upcoming-price-${product.id}`}
        >
          {`Price ${Number(upcomingHeadline) > Number(headline) ? 'increases' : 'changes'} to ${formatPrice(upcomingHeadline, currency)} on ${formatIncreaseDate(upcomingPrice.startsAt)}`}
        </span>
      )}
    </span>
  );
}

ProductPrice.propTypes = {
  product: seriesPassProductShape.isRequired,
  currency: PropTypes.string,
  enableAllInPricing: PropTypes.bool,
  showFeeBreakdown: PropTypes.bool,
};

ProductPrice.defaultProps = {
  currency: 'USD',
  enableAllInPricing: false,
  showFeeBreakdown: true,
};
